import React, { useEffect } from 'react';
import { Typography, Button, Form, Input } from 'antd';
import { ArrowLeftOutlined, SendOutlined, MessageOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';

const { Title } = Typography;
const { TextArea } = Input;

const ContactScreen = () => {
  const gradientTextStyle = {
    backgroundImage: 'linear-gradient(-45deg, #7c3aed, #a855f7, #d946ef)',
    backgroundSize: '200% 200%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
    fontWeight: '900',
  };

  useEffect(() => {
    // Load Tawk.to script
    var s1 = document.createElement("script");
    s1.async = true;
    s1.src = 'https://embed.tawk.to/67c7f923313b66191114a8bb/1iliiaddh';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    document.head.appendChild(s1);

    // Cleanup function to remove script when component unmounts
    return () => {
     // Remove the script tag
     if (s1 && s1.parentNode) {
      s1.parentNode.removeChild(s1);
    }

    // Remove the Tawk.to widget iframe
    const tawkWrapper = document.getElementById('tawk-wrapper');
    if (tawkWrapper) {
      tawkWrapper.remove();
    }

    // Reset Tawk_API
    if (window.Tawk_API) {
      window.Tawk_API = undefined;
    }
    };
  }, []); // Empty dependency array means this runs once when component mounts

  const onFinish = (values) => {
   // console.log('Form values:', values);
    // Handle form submission here
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-gray-50">
      {/* Back Button */}
      <div className="absolute top-4 left-4 z-10">
        <Link to="/">
          <Button 
            type="text"
            icon={<ArrowLeftOutlined />}
            className="flex items-center text-purple-700 hover:text-purple-900 font-semibold text-lg hover:bg-purple-50 rounded-full px-6 py-2 h-auto"
          >
            Back to Home
          </Button>
        </Link>
      </div>

      {/* Background Gradients */}
      <div className="absolute inset-0 bg-[conic-gradient(at_top_right,_var(--tw-gradient-stops))] from-indigo-200/80 via-purple-100/80 to-pink-100/80 -z-10" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-purple-300/30 to-blue-300/30 rounded-full blur-3xl -z-10 animate-pulse" />
      <div className="absolute bottom-0 left-0 w-2/3 h-2/3 bg-gradient-to-tr from-pink-200/30 to-indigo-300/30 rounded-full blur-3xl -z-10 animate-pulse" />

      <div className="container mx-auto px-4 py-12 pt-20">
        <div className="max-w-4xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-6 py-2 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold shadow-lg">
              💬 Get in Touch
            </div>
            <h1 className="text-6xl font-black mb-6" style={gradientTextStyle}>
              Contact Us
            </h1>
            <p className="text-xl text-gray-600">
              We'd love to hear from you. Send us a message and we'll respond as soon as possible.
            </p>
          </div>

          {/* Main Content */}
          <div className="flex justify-center">
            <div className="max-w-lg w-full space-y-6">
              {/* Contact Info */}
              <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-xl border border-white/50 p-8">
                <h3 className="text-2xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-500">
                  Contact Information
                </h3>
                <div className="space-y-4">
                  <p className="flex items-center space-x-3 text-gray-700">
                    <span className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"></span>
                    <span>Email: <a href="mailto:shubhankardev8@gmail.com" className="text-purple-600 hover:text-purple-800">shubhankardev8@gmail.com</a></span>
                  </p>
                  <p className="flex items-center space-x-3 text-gray-700">
                    <span className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"></span>
                    <span>Website: <a href="https://carouselpost.in/" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-800">www.carouselpost.in</a></span>
                  </p>
                </div>
              </div>

              {/* Live Chat Widget Info */}
              <div className="bg-purple-50/50 backdrop-blur-xl rounded-2xl shadow-xl border border-purple-100/50 p-8">
                <div className="text-center space-y-4">
                  <MessageOutlined className="text-4xl text-purple-600" />
                  <h3 className="text-xl font-semibold text-purple-700">Live Chat Available!</h3>
                  <p className="text-gray-600">
                    Need immediate assistance? Click the chat icon in the bottom-right corner to start a conversation with our support team.
                  </p>
                </div>
                <div id="tawk-chat-widget"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactScreen;